import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  NgModule,
} from '@angular/core';
import { SharedUiFormModule } from '@fantaz/shared/ui/form';
import {
  CreditCardFormComponent,
  CreditCardFormPrimaryActionComponent,
  CreditCardFormPrimaryActionsComponent,
} from './credit-card-form.component';

const components = [
  CreditCardFormComponent,
  CreditCardFormPrimaryActionsComponent,
  CreditCardFormPrimaryActionComponent,
];
@NgModule({
  declarations: [...components],
  imports: [CommonModule, SharedUiFormModule],
  exports: [...components],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class CreditCardFormModule {}
